<template>
  <product-landing
    v-if="category"
    :key="$route.path"
    v-bind="category"
    :hide-gradients="hasGradientBackground"
  >
    <template v-if="category.introHero && !usePortalHero" #hero>
      <float v-if="useHeroWindow3d">
        <window-3d skew-left class="sm:text-lg md:text-xl lg:text-2xl">
          <sanity-media v-bind="category.introHero" no-ratio cover fluid />
        </window-3d>
      </float>
      <sanity-media
        v-else-if="category.introHero"
        :image="category.introHero.image"
        class="flex items-center justify-center w-full product-landing__hero--media"
      />
    </template>
    <template v-if="showSpinningCans" #after-grid>
      <gradient
        v-if="!hasGradientBackground"
        :colors="[
          getColor('apricot'),
          getTransparentColor(getColor('melrose'))
        ]"
        force-gradient
        class="absolute top-0 left-0 w-full pointer-events-none h-header-height z-above"
      />
      <page-section
        centered
        full-height
        :cta="category.outroCta"
        :class="{ 'bg-melrose': !hasGradientBackground }"
        class="-mt-1 text-center text-default"
      >
        <div class="container">
          <div class="wrap">
            <div class="mx-auto max-w-2/3 mb-y-gutter-sm md:max-w-1/2">
              <sanity-media
                v-if="category.outroImage"
                class=".page--shop-sparkling-water__outro-image"
                :image="category.outroImage"
              />
              <wreath v-else class="w-full" />
            </div>
            <h3 v-if="category.outroTitle" class="heading">
              {{ category.outroTitle }}
            </h3>
          </div>
        </div>
      </page-section>
    </template>
  </product-landing>
</template>

<script>
import page from '~/mixins/page'
import productLanding from '~/mixins/product-landing'
import ProductLanding from '~/components/shop/products/product-landing.vue'
import Wreath from '~/components/wreath.vue'

export default {
  components: {
    ProductLanding,
    Wreath
  },

  mixins: [page, productLanding],

  data: () => ({
    category: null,
    useHeroWindow3d: false
  }),

  computed: {
    hasGradientBackground() {
      return true
    },
    usePortalHero() {
      return this.category.slug === 'sparkling-water'
    },
    showSpinningCans() {
      return ['sparkling-water'].includes(this.category.slug)
    }
  }
}
</script>

<style>
.page--shop-sparkling-water .page {
  padding-bottom: 0;
}

.product-landing__hero--media img {
  max-height: 400px;
  object-fit: contain;
}

.page--shop-sparkling-water__outro-image {
  max-height: 400px;
}

@screen 2xl {
  .product-landing__hero--media img {
    max-height: 600px;
  }
}
</style>
